import React from 'react';
import { Button, Space, Tooltip, notification } from 'antd';
import {
  DeleteTwoTone,
  UploadOutlined,
  EyeOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import AddFilesModal from '../../../../../../Template/layoutComponents/UploadDocumentPage/components/AddFilesModal';
import TableTip from '../../../../../../Template/layoutComponents/Table/components/tip';

/**
 * Retorna a configuração de colunas da tabela de upload de documentos
 */
export const getTableConfig = ({
  t,
  isLocked,
  deleteDocument,
  fetchDocuments,
  asset,
  type,
  saveFile,
  phaseTitle,
  stageIndex,
  setRefetchIssues,
  systemTask,
}) => {
  const handleDownload = async (fileUrl, fileName) => {
    // Validação inicial
    if (!fileUrl) {
      return notification.error({ message: 'URL do arquivo não encontrada.' });
    }

    try {
      // Usa o fetch para buscar o arquivo
      const response = await fetch(fileUrl);

      if (!response.ok) {
        throw new Error(`Falha na requisição: ${response.statusText}`);
      }

      const blob = await response.blob();

      // Cria uma URL temporária e local para o Blob
      const url = window.URL.createObjectURL(blob);


      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileName || 'download';
      document.body.appendChild(a);
      a.click();


      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
      notification.error({ message: 'Não foi possível baixar o arquivo.' });
    }
  };

  return ({

    columnsConfig: {
      documentName: { label: t('document_name') },
      documentType: { label: t('document_type') },
      uploadedBy: { label: t('uploaded_by') },
      dateTime: { label: t('date_and_time') },
      status: {
        label: t('status'),
        customElement: (item) => <TableTip>{item.status ?? item}</TableTip>,
      },


      manage: {
        label: t('manage'),
        customElement: (row) => (
          <Space>

            {row.documentName !== '-' && (
              <Tooltip title={t('view')}>
                <Button
                  type="text"
                  icon={<EyeOutlined />}
                  onClick={() => {
                    if (!row.fileUrl)
                      return notification.error({ message: 'URL not found' });
                    window.open(row.fileUrl, '_blank', 'noopener,noreferrer');
                  }}
                // disabled={false}
                />
              </Tooltip>
            )}

            {row.documentName !== '-' && (
              <Tooltip title={t('download')}>
                <Button
                  type="text"
                  icon={<DownloadOutlined />}
                  onClick={() => handleDownload(row.fileUrl, row.documentName)}
                // disabled={false}
                />
              </Tooltip>
            )}

            {/* 🗑  Excluir */}
            {row.documentName !== '-' && (
              <Button
                type="text"
                icon={<DeleteTwoTone twoToneColor="#FF4D4F" />}
                onClick={() => deleteDocument(row)}
                disabled={isLocked}
              />
            )}

            {/* 📤  Upload (modal) */}
            <AddFilesModal
              id={asset._id}
              type={type}
              uploadCall={async (...params) => {
                const response = await saveFile(...params);
                setRefetchIssues(true);
                return response;
              }}
              reloadFileList={fetchDocuments}
              fileTransformer={(file) => {
                const customFileName = `phase_${phaseTitle}_${stageIndex}_index_${row.index}_${file.name}`;
                return new File([file.originFileObj], customFileName, { type: file.type });
              }}
              shouldValidate={row.shouldValidate}
              validateItems={row.validateItems}
              task={systemTask?._id}
              stage={phaseTitle}
              customButton={
                row.documentName === '-' ? (
                  <Button type="primary" icon={<UploadOutlined />} disabled={isLocked}>
                    Upload
                  </Button>
                ) : (
                  <div />
                )
              }
            />
          </Space>
        ),
      },
    },
  })
} 
